import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { Router } from '@angular/router';
import { GlobalVariables } from 'src/app/services/local/globalVariables.service';
import { LucideAngularModule } from 'lucide-angular';
import { NgIf } from '@angular/common';


@Component({
    selector: 'app-aside-gral-menu-mobile',
    templateUrl: './aside-gral-menu-mobile.component.html',
    styleUrls: ['./aside-gral-menu-mobile.component.css'],
    imports: [NgIf, LucideAngularModule]
})
export class AsideGralMenuMobileComponent implements OnInit {
  @Input() name: any;
  @Input() calendars: Array<any>
  @Input() activeSection: string = 'calendar';
  @Output() closeMenu = new EventEmitter();
  id: any=0;
  imagepath:string=''

  
  constructor( private router:Router, private globalVariables: GlobalVariables) { }

  activeSectionInternal: string = '';

  ngOnInit(): void {
    this.imagepath=this.globalVariables.getUrlImage()
    this.id= this.globalVariables.getIdWorkPlace()
    if (!this.calendars || !this.calendars.length) {
      this.globalVariables.getNewCalendars$().subscribe((calendars: any)=>{
        if (calendars && calendars.length) this.calendars = calendars;
      });
    }
    this.computeActiveSection();
  }

  ngOnChanges(changes: SimpleChanges)
  {
     if (changes.name)
     {
      this.name=changes.name.currentValue
     }
      
  }

  computeActiveSection(){
    const url = this.router.url || '';
    if (url.includes('/operators/')) this.activeSection = 'operators';
    else if (url.includes('/schedules/')) this.activeSection = 'schedules';
    else this.activeSection = 'calendar';
  }

  clickCloseMenu(event){
    event.stopPropagation();
    event.preventDefault();
    this.closeMenu.emit();
  }

  goToCalendars(event){
    event.stopPropagation();
    event.preventDefault();

    this.id= this.globalVariables.getIdWorkPlace()
    this.router.navigate(['resources/' + this.id + '/' + this.name])
    this.closeMenu.emit();
  }

  goToCalendar(event){
    this.goToCalendars(event);
  }

  buildCalendarsQueryParams(title: string){
    var arrIdCalendar: Array<any>=[]
    const queryParams: any = {};

    if (!this.id)
      this.id= this.globalVariables.getIdWorkPlace()

    (this.calendars || []).forEach((calendar) => {
      if (!arrIdCalendar.some(c => c.idCalendar == calendar.idCalendar)) {
        arrIdCalendar.push({'idCalendar':calendar.idCalendar, 'name':calendar.name, 'shortName': calendar.shortName, 'active': calendar.active})
      }
    });

    queryParams.myArray=JSON.stringify(arrIdCalendar);
    queryParams.name=this.name
    queryParams.title=title
    return { queryParams };
  }

  goToSchedules(event){
    if (event){
      event.stopPropagation();
      event.preventDefault();
    }
    const extras = this.buildCalendarsQueryParams('Horarios');
    this.router.navigate(['panel/' + this.id + '/schedules/' + this.id ], extras)
    this.closeMenu.emit();
  }

  goToOperators(event){
    if (event){
      event.stopPropagation();
      event.preventDefault();
    }
    const extras = this.buildCalendarsQueryParams('Operarios');
    this.router.navigate(['panel/' + this.id + '/operators/' + this.id ], extras)
    this.closeMenu.emit();
  }

  clickExit(event){
    event.stopPropagation();
    event.preventDefault();
    localStorage.clear()
    this.router.navigate(['login']);
    this.closeMenu.emit();
   }

   clickGoMain(event){
    event.stopPropagation();
    event.preventDefault();
    this.router.navigate(['main'], { queryParams: { centres: '1' } });
    this.closeMenu.emit();
   }
}